import DocumentationFactoryRepositoryImpl from './impl/DocumentationRepositoryImpl'

export default {
  getInstance () {
    return new DocumentationFactoryRepositoryImpl()
  }
}
